import { Navigate, Outlet } from "react-router-dom";

export const ProtectedLayout = () => {
  const user = JSON.parse(localStorage.getItem("userData"));

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export const AuthProtectedLayout = () => {
  const user = JSON.parse(localStorage.getItem("userData"));

  if (user) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};
